var map = {
	"./MCDSSkiosks.png": 384,
	"./McDonaldsUserJourney.png": 685,
	"./ShakeShackUserJourney.png": 235,
	"./benchmarkTable.png": 33,
	"./cocotesting1.png": 823,
	"./cocotesting2.png": 629,
	"./conservativeChris.png": 857,
	"./highschoolerAllie.png": 861,
	"./interfaceSolution.png": 188,
	"./metaRakshaHiAva.png": 509,
	"./officeJon.png": 626,
	"./speechSolution.png": 93,
	"./touchImprovements.png": 727,
	"./touchSolution.png": 68,
	"./touchSurvey.png": 797,
	"./userDemographicPie.png": 186,
	"./userTaskTable.png": 446,
	"./voiceJourney.png": 194,
	"./voiceProto1.png": 443,
	"./wireframeComboSides.png": 29,
	"./wireframeDining.png": 247,
	"./wireframeEA.png": 282,
	"./wireframePickCombo.png": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;